// extracted by mini-css-extract-plugin
export default {"card":"styles_card__SrLnW","cardTitle":"styles_cardTitle__RuzdL","image":"styles_image__UApNO","mainTitle":"styles_mainTitle__YxtRv"};